import { ShortenedWarranty } from './../../../../models/shortened-warranty.model';
import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';
import { DocumentsService } from '../../../../services/documents.service';
import { InfoItem, Category } from '../../../generics/data-printer/data-printer.component';
import { Warranty } from '../../../../models/warranty.model';
import { generateTenantCategories, getTenantPerson, Tenant } from '../../../../models/tenant.model';
import { UtilsService } from '../../../../services/utils.service';
import { ErrorResponse } from '../../../../models/error.model';
import { ID } from '../../../../models/ID.model';

@Component({
    selector: 'app-tenant-details-content',
    templateUrl: './tenant-details-content.component.html',
    styleUrls: ['./tenant-details-content.component.scss']
})
export class TenantDetailsContentComponent implements OnInit {

    categories: Category[] = [];

    tenantValue?: Tenant;
    @Input()
    set tenant(newValue: Tenant) {
        this.tenantValue = newValue;
        this.generateCategories(newValue);
    }
    get tenant() {
        return this.tenantValue;
    }

    guarantiesValue?: ShortenedWarranty[];
    @Input()
    set guaranties(newValue: ShortenedWarranty[]) {
        this.guarantiesValue = newValue;
        this.generateCategories(this.tenant);
    }
    get guaranties() {
        return this.guarantiesValue;
    }

    @ViewChild('downloadDocumentButton', { static: true })
    downloadDocumentButtonTempalte: TemplateRef<any>;

    @ViewChild('warrantyDetails', { static: true })
    warrantyDetailsTemplate: TemplateRef<any>;

    constructor(
        private utilsService: UtilsService,
        private documentsService: DocumentsService,
    ) { }

    ngOnInit(): void {
    }

    generateCategories(tenant: Tenant) {
        this.categories = generateTenantCategories(tenant, 'Información general', 'Dirección', 'Representante');
        const poderId = getTenantPerson(tenant)?.representante?.poderAdjunto?.id;
        if (poderId) {
            this.categories[this.categories.length - 1].items.push(
                { template: this.downloadDocumentButtonTempalte, templateParams: { documentId: poderId, label: 'Descargar poder/acta/estatuto' } }
            );
        }
        if (this.guaranties) {
            this.categories.push({ name: 'Garantías', items: this.guaranties.map(warranty => ({ template: this.warrantyDetailsTemplate, templateParams: { warranty } } as InfoItem)) });
        }
    }

    downloadDocument(documentId: ID) {
        this.documentsService.downloadDocument(documentId).subscribe(awsRequest => {
            this.utilsService.downloadFile(awsRequest);
        }, (error: ErrorResponse) => this.utilsService.alert('Error al descargar archivo', error.error?.descripcion));
    }
}
